export default __webpack_public_path__ + "static/media/ba8.cf595d0c.jpg";